
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibition/download",
      function () {
        return require("private-next-pages/exhibition/download/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibition/download"])
      });
    }
  